import { render, staticRenderFns } from "./DentalServices.html?vue&type=template&id=6be83aee&external"
import script from "./DentalServices.js?vue&type=script&lang=js&external"
export * from "./DentalServices.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports